import { CircularProgress, useTheme } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import React from 'react';
import { IPrimaryBtnProps } from './Types';
import { Link } from 'react-router-dom';
import SkeletonContentLoader from '../../shared/SkeletonContentLoader';
import PrimaryBtnSkeleton from './loading-skeleton';

const PrimaryBtn: React.FC<IPrimaryBtnProps> = ({
  text,
  href,
  onClick,
  sx,
  type,
  isLoading = false,
  isSkeletonLoading = false,
  dataTestId,
  color: _color,
  ...props
}) => {
  const theme = useTheme();
  return (
    <SkeletonContentLoader
      isLoading={isSkeletonLoading}
      skeleton={<PrimaryBtnSkeleton />}
    >
      <LoadingButton
        data-testid={dataTestId}
        component={href ? Link : 'button'}
        to={href}
        loading={isLoading}
        loadingIndicator={<CircularProgress size={24} style={{ color: 'white' }} />}
        variant="contained"
        color="primary"
        onClick={onClick}
        type={type}
        {...props}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textDecoration: 'none',
          bgcolor: theme.palette.primary.main,
          borderRadius: '8px',
          color: theme.palette.primary.contrastText || 'white',
          fontSize: 20,
          fontWeight: 500,
          width: '100%',
          textTransform: 'unset',
          height: '55px',
          '&:hover': {
            bgcolor: `${theme.palette.primary.dark || theme.palette.primary.main} !important`,
            boxShadow: `0 4px 12px ${theme.palette.primary.main}33`,
          },
          '&.Mui-disabled': {
            bgcolor: '#D9D9D9',
            color: 'white',
          },
          ...sx,
        }}
      >
        {text}
      </LoadingButton>
    </SkeletonContentLoader>
  );
};

export default PrimaryBtn;
